import React from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';
import { IField } from '../../Hooks/useField';
import { InternalFloatField } from './InternalFloatField';

export type FloatFieldProps = TextFieldProps & {
    field: IField
    updateFieldStateOnChange?: boolean
    onValueChanged?: (newValue: any) => void
    onEnter?: React.KeyboardEventHandler<HTMLDivElement> | undefined
    decimalScale?: number;
    prefix?: string
}

function FloatFieldComponent ({ 
    field, 
    onValueChanged, 
    updateFieldStateOnChange, 
    onEnter,
    onKeyDown,
    fullWidth, 
    helperText, 
    decimalScale,
    ...props
}: FloatFieldProps) {
    const [_value, _setValue] = React.useState(field.value);

    const handleChange = React.useCallback((name: string, value: number | undefined) => {
        _setValue(value);
    }, []);

    const handleKeyDown = React.useCallback((e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter" && onEnter !== undefined) {
            onEnter(e);
        }

        if (onKeyDown !== undefined) {
            onKeyDown(e);
        }
    }, [onEnter, onKeyDown]);

    //Reage à mudança do valor interno
    //Set o valor na ref
    //Chama o evento o change externo
    //Verifica se é para subir o estado automaticamente através da propriedade updateFieldStateOnChange
    React.useEffect(() => {
        field.setInputValue(_value);

        if (onValueChanged !== undefined) {
            onValueChanged(_value);
        }

        if (updateFieldStateOnChange === true && field.value !== _value) {
            field.setValue(_value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_value, onValueChanged, updateFieldStateOnChange]);

    //Reage à mudança do valor externo
    //Atualiza o valor interno pelo valor externo
    React.useEffect(() => {
        if (field.value !== _value) {
            _setValue(field.value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.value]);

    React.useEffect(() => {
        if (field.transition === "reset") {
            _setValue(field.initialValueRef?.current);
            field.clearTransition();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.transition]);

    return (
        <TextField
            {...props}
            name={field.name}
            //value={_value !== undefined && _value !== null ? _value : ""}
            //onChange={handleChange}
            fullWidth={fullWidth !== false}
            helperText={!!field.error ? field.error : helperText}
            error={!!field.error}
            inputProps={{
                style: {
                    textAlign: 'right'
                }
            }}
            InputLabelProps={{
                shrink: props.InputLabelProps?.shrink || !!(_value || "0").toString()
            }}
            InputProps={{
                ...props.InputProps,
                value: _value !== undefined && _value !== null ? _value : "",
                onChange: handleChange as any,
                onKeyDown: handleKeyDown as any,
                inputComponent: InternalFloatField as any,
            }}
        />
    );
}

export const FloatField = React.memo(FloatFieldComponent);

